var _excluded = ["children"];
var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/wrench/components/nav-bar/NavBar.tsx",
  _this = this;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Box } from '@wds/box';
import { safeRest } from '@wds/utils';
import { useHeaderTheme } from '../../theme';
import useStyles from './useStyles';
var NavBar = function NavBar(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useHeaderTheme();
  var classes = useStyles({
    theme: theme
  });
  return /*#__PURE__*/React.createElement("header", Object.assign({
    className: classes.navBar
  }, safeRest(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    flexAlign: "center",
    flexJustify: "space-between",
    className: classes.navBarBox,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 7
    }
  }, children));
};
export default NavBar;
export { NavBar };
//# sourceMappingURL=NavBar.js.map